var map = {
	"./action_shap.png": 75875,
	"./banner_bg.png": 5592,
	"./divider.png": 71139,
	"./dot.png": 60937,
	"./review1.jpeg": 31262,
	"./review2.jpeg": 42571,
	"./review3.jpeg": 9828,
	"./review4.jpeg": 17425,
	"./review5.jpeg": 14474
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79048;